import React from "react";
import PropTypes from "prop-types";

const CobeeInput = ({
  labelText,
  inputType,
  placeholder,
  changeText,
  value,
  required,
  pattern,
}) => {
  return (
    <div className="cob-input-group">
      {labelText && <span className="input-label">{labelText}</span>}
      <input
        pattern={pattern}
        type={inputType}
        placeholder={placeholder || labelText}
        onChange={(e) => changeText(e)}
        value={value}
        required={required}
      />
    </div>
  );
};

CobeeInput.defaultProps = {
  labelText: "",
  inputType: "text",
  placeholder: "",
  changeText: () => {},
  required: false,
  pattern: null,
};

CobeeInput.propTypes = {
  labelText: PropTypes.string,
  inputType: PropTypes.string,
  placeholder: PropTypes.string,
  changeText: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  required: PropTypes.bool,
  pattern: PropTypes.string,
};

export default CobeeInput;
